import React from 'react';
import './index.scss';
import { formatTextFloat, formatPrice } from '../../../../../helpers/Text';
import { getDataFollowKeyByDot } from '../../../../../helpers/Common';
import { getColorPrice } from './../../../../../helpers/Color';
import TextBlinkCustom from '../../../../../common/text-blink-custom';
import PriceInfo from '../../../../../common/index-summary/PriceInfo';
import Const from '../../../../../common/Const';

class IndexSumary extends React.Component {
  getDataByTypeSearch = (priceParam, referencePriceParam) => {
    let price = formatTextFloat(formatPrice(priceParam));
    let referencePrice = formatTextFloat(formatPrice(referencePriceParam));

    return [price, referencePrice];
  };

  getChangeByTypeSearch = () => {
    const { indexSumaryRealTime } = this.props;

    return formatTextFloat(
      formatPrice(
        getDataFollowKeyByDot(
          indexSumaryRealTime,
          Const.indexData.VALUE_CHANGE,
        ),
      ),
    );
  };

  renderPriceInfo = () => {
    const { indexSumaryRealTime } = this.props;
    const price = getDataFollowKeyByDot(
      indexSumaryRealTime,
      Const.indexData.VALUE,
    );
    const referencePrice = getDataFollowKeyByDot(
      indexSumaryRealTime,
      Const.indexData.REFERENCE_PRICE,
    );

    const cellingPrice = getDataFollowKeyByDot(
      indexSumaryRealTime,
      Const.indexData.CEILING_PRICE,
    );

    const floorPrice = getDataFollowKeyByDot(
      indexSumaryRealTime,
      Const.indexData.FLOOR_PRICE,
    );

    const dataFormat = this.getDataByTypeSearch(price, referencePrice);

    return (
      <div className="left-info-widget__metas">
        <PriceInfo
          price={formatTextFloat(dataFormat[0])}
          referencePrice={dataFormat[1]}
          change={this.getChangeByTypeSearch()}
          percentChange={formatTextFloat(
            getDataFollowKeyByDot(
              indexSumaryRealTime,
              Const.indexData.PERCENT_VALUE_CHANGE,
            ) * 100,
          )}
          classNameColor={getColorPrice(
            price,
            referencePrice,
            cellingPrice,
            floorPrice,
          )}
        />
      </div>
    );
  };

  render() {
    const { indexSumaryRealTime, isRealTime } = this.props;

    if (isRealTime) {
      return (
        <TextBlinkCustom data={indexSumaryRealTime} compareKey={'tradingDate'}>
          {this.renderPriceInfo()}
        </TextBlinkCustom>
      );
    }
    return this.renderPriceInfo();
  }
}

export default IndexSumary;
